import { render, staticRenderFns } from "./Teams-Single.vue?vue&type=template&id=a1703458"
import script from "./Teams-Single.js?vue&type=script&lang=js&external"
export * from "./Teams-Single.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports